import React, { useRef, useState } from 'react';
import { Popover } from '@material-ui/core';
import InfoIcon from '../../icons/InfoIcon';
import styles from "./InfoIconWithPopover.module.css"

const InfoIconWithPopover = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const openPopup = () => setIsPopupOpen(true);
    const closePopup = () => setIsPopupOpen(false);
    const iconRef = useRef(null);
    return (
        <>
            <InfoIcon style={{ color: '#F17C7C', fontSize: '1em' }}
                className={styles.infoIcon}
                onClick={openPopup}
                ref={iconRef}
            />
            <Popover
                open={isPopupOpen}
                anchorEl={iconRef.current}
                onClose={closePopup}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
            >
                <div
                    style={{
                        margin: '10px',
                        width: '200px',
                        height: '40px'
                    }}
                >
                    Select checkbox and edit <br /> to perform the corrections
                </div>
            </Popover>
        </>
    )
}

export default InfoIconWithPopover;